import { useAccommodationPlacesByCoupleQuery } from '@graphql/generated';
import { useEventInfo } from '@shared/utils/eventInfo';
import { useMemo } from 'react';

export const useAccommodationPlacesByCouple = () => {
  const { eventHandle } = useEventInfo();
  const { data, loading, error } = useAccommodationPlacesByCoupleQuery({
    variables: {
      name: eventHandle || ''
    },
    batchMode: 'fast'
  });

  const filteredAccommodationPlaces = useMemo(
    () =>
      data?.eventByName?.accommodationPlacesV2
        ?.filter(place => place.isFromAccommodationCatalog && place.joyPlaceId)
        ?.filter((place, index, self) => self.findIndex(p => p.joyPlaceId === place.joyPlaceId) === index),
    [data?.eventByName?.accommodationPlacesV2]
  );

  return {
    accommodationPlaces: filteredAccommodationPlaces,
    loading,
    error
  };
};
